import { useQuery} from '@tanstack/react-query';
import {axiosClient} from '../axiosClient';

export const getHousingAssociationReport = async (housingAssociationId: string | null, year: number | null): Promise<string | null> => {
  const URL = `${import.meta.env.VITE_API_HOUSING_ASSOCIATION_URL}/report?housing_association_id=${housingAssociationId}&year=${year}`;
  const {data} = await axiosClient.get(URL, {
    responseType: "blob"
  });

  const pdfUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
  return pdfUrl;
}

const useHousingAssociationReport = (housingAssociationId: string | null, year: number | null) => {
  return useQuery({
    queryKey: ['housing-association-report', housingAssociationId, year],
    queryFn: () => getHousingAssociationReport(housingAssociationId, year),
    enabled: !!housingAssociationId && !!year,
  });
}

export default useHousingAssociationReport;